import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private readonly TOKEN_KEY = 'auth_token';

  constructor(private http: HttpClient) {}

  /**
   * Obtiene el token JWT del localStorage
   */
  getToken(): string | null {
    const token = localStorage.getItem(this.TOKEN_KEY);
    return token;
  }

  setToken(token: string): void {
    localStorage.setItem(this.TOKEN_KEY, token);
  }

  removeToken(): void {
    localStorage.removeItem(this.TOKEN_KEY);
  }

  hasToken(): boolean {
    return this.getToken() !== null;
  }

  generateToken(): Promise<void> {
    const tokenQuemado =
      'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJodHRwOi8vc2NoZW1hcy54bWxzb2FwLm9yZy93cy8yMDA1LzA1L2lkZW50aXR5L2NsYWltcy9uYW1lIjoiUExBVEZPUk0tRlJPTlQiLCJpZEthdGlvcyI6IlRGQSIsInBlb3BsZWFwaS5wZXJmaWxlcy5lZGl0YXIiOiJmYWxzZSIsInBlb3BsZWFwaS5wZXJmaWxlcy52ZXIiOiJmYWxzZSIsInBlb3BsZWFwaS5wZXJzb25hcy5lZGl0YXIiOiJmYWxzZSIsInBlb3BsZWFwaS5wZXJzb25hcy52ZXIiOiJmYWxzZSIsInBlb3BsZWFwaS5yb2xlcy5lZGl0YXIiOiJmYWxzZSIsInBlb3BsZWFwaS5yb2xlcy52ZXIiOiJmYWxzZSIsImlzcyI6InRmbmJ4LWF1dGgtc3ZjLWRldiIsImF1ZCI6Imh0dHBzOi8vdGZuYngtYXV0aC1zdmMtZGV2LmF6dXJld2Vic2l0ZXMubmV0L0xvZ2luIn0.6cfEiMvCOIiSDNX7T4ACGrQF67kX_0tCPVAlac14-WY';
    this.setToken(tokenQuemado);
    return Promise.resolve();

    /*
    const url = `${this.AUTH_URL}?User=${this.AUTH_PARAMS.User}&Pass=${this.AUTH_PARAMS.Pass}&TipoAuth=${this.AUTH_PARAMS.TipoAuth}`;
    console.log('[AuthService] Iniciando generación de token...');
    console.log('[AuthService] URL:', url);

    return firstValueFrom(
      this.http.get<{ token: string }>(url)
    ).then((response) => {
      if (!response.token) {
        throw new Error('No token en la respuesta del servidor');
      }
      this.setToken(response.token);
      console.log('[AuthService] ✓ Token JWT generado exitosamente');
      return;
    }).catch((error) => {
      console.error('[AuthService] ✗ Error al generar el token JWT:', error);
      throw error;
    });
    */
  }
}
